import React, { useState } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { Controls } from '../../components/controls/Controls';
import useToast from '../../hooks/useToast';
import ConfirmationModal from '../_common/ConfirmationModal';
import { convertAxiosErrorToUserFacingMessage, useApiClient } from '../../context/ApiClientContext';
import basicServiceHandler from '../../services/basicServiceHandler';
import useAuth from '../../hooks/useAuth';

export default function PushContentToProductionSection({ refreshLogs }) {
  const [selectedPipeline, setSelectedPipeline] = useState({
    label: '',
    pipeline: '',
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const apiClient = useApiClient();
  const { hasRole } = useAuth();
  const hasSuperAdmin = hasRole('SuperAdmin');

  const {
    toastSetSuccessNotification,
    toastSetErrorNotification,
  } = useToast();

  const handleOpenConfirmModal = (pipeline) => {
    setSelectedPipeline(pipeline);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => setIsModalOpen(false);

  const handlePushContentToProductionDatabase = async (pipeline) => {
    basicServiceHandler(
      () => apiClient.runPipeline(pipeline),
      () => {
        toastSetSuccessNotification(`Content pushed to ${pipeline} database started. Use the refresh button to monitor status.`);
        setIsModalOpen(false);
        refreshLogs();
      },
      (error) => toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error)),
      {},
    );
  };

  const handlePushContentToProductionDatabaseConfirm = () => {
    if (selectedPipeline) {
      handlePushContentToProductionDatabase(selectedPipeline.pipeline);
      setIsModalOpen(false);
    }
  };

  const medicalContentPipelines = [
    { label: 'CA Production', pipeline: 'PushContentToCAProductionDatabase' },
    { label: 'US Production', pipeline: 'PushContentToUSProductionDatabase' },
    { label: 'SA Stc Production', pipeline: 'PushContentToSAStcProductionDatabase' },
    ...(hasSuperAdmin ? [
      { label: 'Dev', pipeline: 'PushContentToDevDatabase' },
      { label: 'Dev Testing', pipeline: 'PushContentToDevTestingDatabase' },
    ] : []),
  ];

  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: '1px solid #c6c6c6',
        borderRadius: '4px',
      }}
    >
      <Typography variant="h5" align="center" sx={{ mb: 2, fontWeight: 'bold' }}>
        Push Content to Production Database
      </Typography>
      <ConfirmationModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handlePushContentToProductionDatabaseConfirm}
      >
        <Typography>
          Are you sure you want to push medical content from
          <strong> Translation Test </strong>
          to
          {' '}
          <strong>{selectedPipeline.label}</strong>
          ?
          <br />
          <br />
          This action cannot be undone.
        </Typography>
      </ConfirmationModal>
      {medicalContentPipelines.map((mcPipeline) => (
        <Controls.Button
          key={mcPipeline.pipeline}
          sx={{ m: 2 }}
          variant="outlined"
          text={`Push content to ${mcPipeline.label}`}
          onClick={() => handleOpenConfirmModal(mcPipeline)}
        />
      ))}
    </Box>
  );
}

PushContentToProductionSection.propTypes = {
  refreshLogs: PropTypes.func.isRequired,
};
